<rpshared-save-bar
	[title]="title$ | async"
	[isSaving]="isSaving$ | async"
	[isFormInvalid]="invalidSubmission$ | async"
	(save)="save($event)"
></rpshared-save-bar>

<div [formGroup]="form" gdGap="10px" class="with-fixed-sub-toolbar">
	<rpshared-mat-loading-card
		[isLoading]="isLoadingCustomer$ | async"
		icon="train"
		title="General Information"
	>
		<rpfsa-customer-general-info
			gdColumns="repeat(auto-fill, minmax(250px, 1fr))"
			gdGap="10px"
			formControlName="generalInfo"
		></rpfsa-customer-general-info>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		[isLoading]="isLoadingCustomer$ | async"
		icon="train"
		title="Address"
	>
		<rpshared-address formControlName="address"> </rpshared-address>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		[isLoading]="isLoadingCustomer$ | async"
		icon="flag"
		title="Jobs"
	>
		<rpfsa-job-list [jobs]="jobs$ | async"></rpfsa-job-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		[isLoading]="isLoadingCustomer$ | async"
		icon="supervised_user_circle"
		title="Field Workers"
	>
		<rpfsa-rwic-list [rwics]="rwics$ | async"></rpfsa-rwic-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingCustomer$ | async"
		[isLoading]="isLoadingCustomer$ | async"
		icon="contacts"
		title="Contacts"
	>
		<rpshared-contact-list
			formControlName="contacts"
		></rpshared-contact-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingCustomer$ | async"
		[isLoading]="isLoadingCustomer$ | async"
		icon="file_copy"
		title="Documents"
	>
		<rpshared-document-list
			[parentId]="id$ | async"
			target="Customer"
			formControlName="documents"
		></rpshared-document-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingCustomer$ | async"
		[isLoading]="isLoadingCustomer$ | async"
		icon="train"
		title="Railroads"
	>
		<rpfsa-railroad-list
			[railroads]="railroads$ | async"
		></rpfsa-railroad-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingCustomer$ | async"
		[isLoading]="isLoadingCustomer$ | async"
		icon="attach_money"
		title="Contracted Rates"
	>
		<rpshared-contract-rates formControlName="contractedRates">
		</rpshared-contract-rates>
	</rpshared-mat-loading-card>
</div>
